import { ContentArea } from '../models/invoice/invoice-document-detail.model';
import { SectionType } from '../../features/invoice-theme/theme.types';
import { InvoiceDateMetaKey } from '../../pages/finances/invoices/invoice.config';
import { dataDynamicFieldMetaKey } from '../../features/invoice-theme/theme.constants';

export const defaultInvoiceHeaderLogo: ContentArea = {
  type: SectionType.Image,
  meta: {
    width: '150',
    height: '150',
    alt: 'logo',
    src: './assets/img/mock/logo-placeholder.png',
  },
};

export const defaultInvoiceHeaderText: ContentArea = {
  type: SectionType.HTML,
  content:
    '<strong class="info-title">Xemedo OG</strong>\n' +
    '<div class="k-font-weight-normal">Paschingerstraße 111</div>\n' +
    '<div class="k-font-weight-normal">4060 – Leonding</div>\n' +
    '<div class="k-font-weight-normal" >https://xemedo.com</div>\n' +
    '<div class="k-font-weight-normal">+43 (0) 732 / 266 400</div>\n' +
    '<div class="k-font-weight-normal">office&#64;xemedo.com</div>\n',
};

export const defaultInvoiceContentSectionOne: ContentArea = {
  type: SectionType.HTML,
  content: `
            <h1>RECHNUNG</h1>
            <div>
              <strong>Der komplette Unternehmensname inklusive Gesellschaftstyp</strong>
            </div>
            <div>Straße und Hausnummer</div>
            <div>Postleitzahl und Ort</div>
            <br />
            <table>
              <colgroup>
                <col style="width: 171px" />
                <col />
              </colgroup>
              <tr>
                <td>Rechnungsdatum:</td>
                <td><span ${dataDynamicFieldMetaKey}="${InvoiceDateMetaKey}"></span></td>
              </tr>
              <tr>
                <td>Rechnungsnummer:</td>
                <td>-</td>
              </tr>
              <tr>
                <td>Kunden-ID:</td>
                <td>—</td>
              </tr>
              <tr>
                <td>Projekt-ID:</td>
                <td>—</td>
              </tr>
              <tr>
                <td>Projektname:</td>
                <td>—</td>
              </tr>
              <tr>
                <td>Leistungszeitraum:</td>
                <td>—</td>
              </tr>
            </table>
          `,
};

export const defaultInvoiceContentSectionTwo: ContentArea = {
  type: SectionType.HTML,
  content: `
           <p>
              <span><strong>Hinweis: </strong></span>
              <span style="font-size: 12px">Alle Beträge sind in Euro angegeben. Zahlbar innerhalb von 14 Tagen ab Rechnungsdatum.</span>
            </p>
            <br />
            <p class="k-mt-2">Für Rückfragen stehen wir gerne zur Verfügung.</p>
            <br />

            <h2>DANKE.</h2>
            <p>
              Wir bedanken uns sehr für die erfolgreiche Zusammenarbeit und würden uns freuen, in
              Zukunft wieder mit Ihnen zu arbeiten.
            </p>
            <br />
            <div class="signature-images-wrapper k-mt-9">
              <img
                src="./assets/img/mock/signature-placeholder.png"
                alt="signature"
                width="250"
                height="97"
              />
            </div>
          `,
};

export const defaultInvoiceFooterContentSectionOne: ContentArea = {
  type: SectionType.HTML,
  content: `<div>
              <strong class="info-title">Xemedo OG</strong>
            </div>
            <div>
              <span>Paschingerstraße 111</span>
            </div>
            <div>
              <span>4060 – Leonding</span>
            </div>
            <div><span>Firmenbuchnummer</span></div>`,
};

export const defaultInvoiceFooterContentSectionTwo: ContentArea = {
  type: SectionType.HTML,
  content: `<div>office&#64;xemedo.com</div>
            <div>https://xemedo.com</div>
            <div>+43 (0) 732 / 266 400</div>
            <div>529404 k</div>`,
};

export const defaultInvoiceFooterContentSectionThree: ContentArea = {
  type: SectionType.HTML,
  content: `<div>Bank: Oberösterreichische Sparkasse</div>
            <div>IBAN: AT48 2032 0321 0054 2517</div>
            <div>BIC: ASPKAT2LXXX</div>
            <div>UID: ATU75426059</div>`,
};

export const defaultInvoiceFooterContentSectionFour: ContentArea = {
  type: SectionType.Image,
  meta: {
    width: '120',
    height: '97',
    alt: 'logo',
    src: './assets/img/mock/logo-placeholder.png',
  },
};
